import React from 'react';

export type MessageChannel = 'whatsapp' | 'rcs';

type Props = {
  value: MessageChannel;
  onChange: (next: MessageChannel) => void;
  disabled?: boolean;
};

const WhatsAppChannelToggle: React.FC<Props> = ({ value, onChange, disabled }) => (
  <div className="inline-flex rounded-xl border border-gray-200 bg-white p-1 dark:border-gray-700 dark:bg-gray-900">
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange('whatsapp')}
      className={`rounded-lg px-3 py-1.5 text-sm font-medium ${
        value === 'whatsapp'
          ? 'bg-[#25D366] text-white'
          : 'text-gray-600 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800'
      }`}
    >
      WhatsApp
    </button>
    <button
      type="button"
      disabled={disabled}
      onClick={() => onChange('rcs')}
      className={`rounded-lg px-3 py-1.5 text-sm font-medium ${
        value === 'rcs'
          ? 'bg-violet-600 text-white'
          : 'text-gray-600 hover:bg-gray-50 dark:text-gray-300 dark:hover:bg-gray-800'
      }`}
    >
      RCS
    </button>
  </div>
);

export default WhatsAppChannelToggle;
